import { ExperimentItem, Variants_Enum } from './types'

export const experiments: readonly ExperimentItem[] = [
  {
    id: 'pix_default_payment_method_v2',
    description: 'Pix como meio de pagamento padrão v2',
    setInitialValueInSSR: true,
    setInitialValueInHook: false,
    variants: [
      {
        id: 'control',
        value: Variants_Enum.A,
        weight: 50,
      },
      {
        id: 'variant',
        value: Variants_Enum.B,
        weight: 50,
      },
    ],
  },
]
